import { useRef, useEffect, useCallback } from 'react'

const useDebounce = (callback, delay) => {
  const debouncedFn = useRef(null)

  useEffect(() => {
    return () => {
      if (debouncedFn.current) {
        clearTimeout(debouncedFn.current)
      }
    }
  }, [])

  return useCallback(
    (...args) => {
      if (debouncedFn.current) {
        clearTimeout(debouncedFn.current)
      }

      debouncedFn.current = setTimeout(() => {
        callback(...args)
      }, delay)
    },
    [callback, delay]
  )
}

export default useDebounce
